import { Controller } from "@hotwired/stimulus"

// Locks the submit button width before Turbo swaps the label for
// data-turbo-submits-with (e.g. a spinner), then clears it when done.
export default class extends Controller {
  connect () {
    this.form = this.element.form || this.element.closest("form")
    if (!this.form) return

    this.onSubmitStart = this.lockWidth.bind(this)
    this.onSubmitEnd = this.unlockWidth.bind(this)
    this.form.addEventListener("turbo:submit-start", this.onSubmitStart)
    this.form.addEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  disconnect () {
    this.form?.removeEventListener("turbo:submit-start", this.onSubmitStart)
    this.form?.removeEventListener("turbo:submit-end", this.onSubmitEnd)
  }

  lockWidth () {
    this.element.style.minWidth = `${this.element.offsetWidth}px`
  }

  unlockWidth () {
    this.element.style.minWidth = ""
  }
}
